export enum GeneratorType {
    Chart = 1,
    Table = 2,
    Card = 3
}
